<template>
  <div style="height: inherit">
    <encuesta-form
      :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formType"
      :data-edit="dataEdit"
      :img-logo="imgLogo"
      @refetch-data="refetchData"
      @error-data="showError"
    />
    <b-modal
      v-model="modalShowClonar"
      size="lg"
      :title="titleModalClonar"
      ok-title="Clonar"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      no-close-on-esc
      :busy="isBusyClonar"
      @ok="okMdlClonar"
    >
      <b-overlay
        :show="isBusyClonar"
        rounded="sm"
      >
        <clonacion-form
          ref="refClonarForm"
          :is-busy-clonar.sync="isBusyClonar"
          :modal-show.sync="modalShowClonar"
          :type-action="typeActionClonar"
          :data-clone="dataClone"
          @refetch-data="refetchData"
          @error-data="showError"
        />
      </b-overlay>
    </b-modal>
    <b-card
      no-body
      class="mb-0"
    >
      <b-card-body>
        <div
          v-if="isBusyEn"
          class="text-center text-primary my-2"
        >
          <b-spinner
            variant="primary"
            class="align-middle"
          />
          <strong class="ml-1">Cargando...</strong>
        </div>
        <!-- Overlay -->
        <div class="body-content-overlay" />

        <!-- Searchbar -->
        <div class="ecommerce-searchbar mt-1">
          <b-row>
            <b-col cols="12">
              <!-- dropdown in both side -->
              <b-input-group>
                <b-input-group-prepend>
                  <b-dropdown variant="outline-primary">
                    <template #button-content>
                      <feather-icon icon="FilterIcon" />
                    </template>
                    <b-dropdown-item>Proyecto </b-dropdown-item>
                  </b-dropdown>
                </b-input-group-prepend>
                <b-form-input
                  v-model="query"
                  placeholder="Buscar una encuesta...."
                />
                <b-input-group-append>
                  <b-button
                    variant="success"
                  >
                    Buscar
                  </b-button>
                  <b-button
                    variant="primary"
                    class="btn-block"
                    style="margin-left: 0.6%;"
                    @click="openForm('new')"
                  >
                    Nuevo
                  </b-button>
                  <!-- <b-dropdown
                    text="Acción"
                    variant="outline-primary"
                    right
                  >
                    <b-dropdown-item
                      @click="openForm('new')"
                    >
                      Nuevo
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="openClone()"
                    >
                      Clonar
                    </b-dropdown-item>
                  </b-dropdown> -->
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </div>
        <!-- Encuestas -->
        <div
          v-if="itemsPolls.length<=0 && !isBusyEn"
          class="text-center text-primary my-2"
        >
          <strong class="ml-1">No se encontraron ningún registro</strong>
        </div>
        <section class="grid-view">
          <b-card
            v-for="(poll, idEncuesta) in itemsPolls"
            :key="idEncuesta"
            class="ecommerce-card"
            no-body
          >
            <b-card-header style="padding:0px !important">
              <b-card-title />
              <!-- Dropdown -->
              <div
                class="dropdownGrid"
              >
                <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="18"
                      class="text-body cursor-pointer"
                    /><!-- style="background-color: yellow;text-align: center !important;position: absolute;top: 16px;" -->
                  </template>
                  <b-dropdown-item @click="getEdit(poll)">
                    Editar
                  </b-dropdown-item>
                  <b-dropdown-item @click="getDelete(poll)">
                    Eliminar
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="userData.idInstitucion===0"
                    @click="getClonar(poll)"
                  >
                    Clonar
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <!-- <feather-icon
                icon="MoreVerticalIcon"
                size="18"
                class="cursor-pointer"
              /> -->
              <div
                class="item-img text-center"
                style="min-height: 0rem !important"
              >
                <b-link>
                  <b-img
                    :alt="`${poll.titulo}`"
                    fluid
                    class="card-img-top"
                    :src="imgData[poll.idEncuesta]"
                  />
                </b-link>
              </div>
            </b-card-header>
            <!-- Product Details -->
            <b-card-body>
              <div class="item-wrapper">
                <div
                  v-b-tooltip.hover.top="`Total preguntas: ${poll.totalPregunta}`"
                >
                  <feather-icon
                    icon="MessageCircleIcon"
                    size="21"
                    class="text-primary"
                    :badge="poll.totalPregunta"
                  />
                  <!-- <b-badge
                    pill
                    variant="light-primary"
                  >
                    6 New
                  </b-badge> -->
                </div>
                <!--<div class="item-rating">
                  <feather-icon
                    icon="MessageCircleIcon"
                    class="mr-50"
                  />
                  24
                </div> -->
                <div>
                  <h6 class="item-price">
                    <feather-icon
                      icon="CalendarIcon"
                      class="mr-100"
                    />
                    {{ poll.createdAt }}
                  </h6>
                </div>
              </div>
              <h6 class="item-name">
                <b-link
                  v-b-tooltip.hover.top="poll.titulo"
                  class="text-body"
                >
                  Título: {{ poll.titulo }}
                </b-link>
                <b-card-text class="item-company">
                  By <b-link class="ml-25">
                    {{ poll.tipo_vista }}
                  </b-link>
                </b-card-text>
              </h6>
              <b-card-text
                v-b-tooltip.hover.top="poll.descripcion"
                class="item-description"
              >
                {{ poll.descripcion }}
              </b-card-text>
            </b-card-body>
            <!-- Product Actions -->
            <div class="item-options text-center">
              <div class="item-wrapper">
                <div class="item-cost">
                  <h4 class="item-price">
                    ${{ poll.tipoVista }}
                  </h4>
                </div>
              </div>
              <b-button
                v-b-tooltip.hover.top="`Institución: ${poll.proyecto.institucion.nombre}  Proyecto: ${poll.proyecto.nombre}`"
                variant="light"
                tag="a"
                class="btn-wishlist"
              >
                Dependencia: {{ poll.proyecto.nombre }}
              </b-button>
              <b-button
                variant="primary"
                tag="a"
                class="btn-cart"
                @click="$router.push({ name: 'app-encuesta-pregunta', params: { id:poll.idEncuesta }})"
              >
                <feather-icon
                  icon="MessageCircleIcon"
                  class="mr-50"
                />
                <span>Gestionar Preguntas</span>
              </b-button>
            </div>
          </b-card>
        </section>
        <!-- Pagination -->
        <section>
          <b-row>
            <b-col cols="12">
              <b-pagination
                v-model="page"
                :total-rows="totalItemsPolls"
                :per-page="perPage"
                first-number
                align="center"
                last-number
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </section>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend, BDropdown, BDropdownItem, BInputGroupPrepend, BButton, BCard, BLink, BImg, BCardBody, BCardText, BPagination, VBTooltip, BCardHeader, BCardTitle, BSpinner, BOverlay,
} from 'bootstrap-vue'
import store from '@/store'
import moment from 'moment'
import Ripple from 'vue-ripple-directive'
import EncuestaForm from './EncuestaForm.vue'
import loading1 from '../../../assets/images/encuesta/loading.gif'
import ClonacionForm from './ClonacionForm.vue'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BInputGroupPrepend,
    BButton,
    BCard,
    BLink,
    BImg,
    BCardBody,
    BCardText,
    BPagination,
    BCardHeader,
    BCardTitle,
    EncuestaForm,
    BSpinner,
    ClonacionForm,
    BOverlay,
    // BDropdownDivider,
  },
  /* setup(){
    const {
      itemView, itemViewOptions, totalProducts,
    } = useShopUi()

  }, */
  data: () => ({
    totalItemsPolls: 0,
    itemsPolls: [],
    isAddNewSidebarActive: false,
    formType: '',
    dataEdit: {},
    imgLogo: null,
    total: 5,
    page: 1,
    perPage: 10,
    query: '',
    totalPage: 0,
    totalRows: 0,
    from: 0,
    to: 0,
    of: 0,
    imgLoading: loading1,
    isLoading: false,
    isBusyEn: false,
    imgData: [],
    modalShowClonar: false,
    isBusyClonar: false,
    titleModalClonar: 'Clonación de Encuesta',
    typeActionClonar: 'new',
    userData: JSON.parse(localStorage.getItem('userData')),
    dataClone: {},
  }),
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    getClonar(data) {
      this.modalShowClonar = true
      this.titleModalClonar = `Clonar Encuesta: ${data.titulo}`
      this.dataClone = data
    },
    okMdlClonar(ev) {
      ev.preventDefault()
      this.$refs.refClonarForm.saveForm()
    },
    openForm(type) {
      this.formType = type
      this.isAddNewSidebarActive = true
      this.imgLogo = null
    },
    getEdit(data) {
      this.formType = 'edit'
      this.isAddNewSidebarActive = true
      this.dataEdit = data
      this.imgLogo = null
    },
    async listarRegistros() {
      this.itemsPolls = []
      this.isBusyEn = true
      this.isLoading = true
      await store
        .dispatch('gsencuesta/ENCUESTA_FIND_ALL', {
          limit: this.perPage,
          query: this.query,
          page: this.page,
          sortBy: 'idEncuesta%7CDESC',
        })
        .then(response => {
          this.itemsPolls = []
          response.items.forEach((dat, index) => {
            const ca = moment(dat.createdAt).format('DD/MM/YYYY')
            const fi = (!dat.fechaInicio || dat.fechaInicio === null) ? '' : moment(dat.fechaInicio).format('YYYY-MM-DD')
            const ff = (!dat.fechaFin || dat.fechaFin === null) ? '' : moment(dat.fechaFin).format('YYYY-MM-DD')
            const self = this
            this.imgData[dat.idEncuesta] = this.imgLoading
            this.itemsPolls.push({
              index,
              titulo: dat.titulo,
              idEncuesta: dat.idEncuesta,
              descripcion: dat.descripcion,
              urlGuia: dat.url_guia,
              expira: dat.expira,
              proyecto: dat.proyecto,
              sourceMultimedia: dat.sourceMultimedia,
              createdAt: ca,
              fechaInicio: fi,
              fechaFin: ff,
              tipoVista: dat.tipoVista,
              dinamico: dat.dinamico,
              publicado: dat.publicado,
              meta: dat.meta,
              esquema: dat.esquema,
              requeridoObservacion: dat.requeridoObservacion,
              requeridoMultimedia: dat.requeridoMultimedia,
              estado: dat.estado,
              esRetomado: dat.esRetomado,
              encuestadoIngresoManual: dat.encuestadoIngresoManual,
              logoName: dat.logo,
              totalPregunta: (dat.pregunta.length === 0) ? '0' : dat.pregunta.length,
            })
            self.imgData[dat.idEncuesta] = dat.logo
            this.totalItemsPolls = response.totalItems
          })
          this.totalRows = response.totalRows
          this.totalItemsPolls = response.totalItems
          this.totalPage = response.totalPage
          this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
          this.to = this.perPage * (this.page - 1) + this.totalRows
          this.of = this.totalItems
          this.isBusyEn = false
          this.isLoading = false
        })
        .catch(error => {
          this.showError(error)
          this.isBusyEn = false
          this.isLoading = false
        })
    },
    async getLogo(data) {
      await store
        .dispatch('gsencuesta/ENCUESTA_FIND_LOGO', {
          idEncuesta: data.idEncuesta,
        })
        .then(response => response)
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    getDelete(data) {
      this.$swal({
        title: '¿Está seguro de eliminar este registro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('gsencuesta/ENCUESTA_DELETE', {
              id: data.idEncuesta,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errorMessage, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
/* .ecommerce-application .grid-view {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr !important;
    -webkit-column-gap: 2rem;
    -moz-column-gap: 2rem;
    column-gap: 2rem;
} */
[dir] .ecommerce-application .grid-view .ecommerce-card .item-img {
    padding-top: 0.0rem !important;
}
.dropdownGrid{
  background-color: #F8F8F8!important;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 5%!important;
  /*position: absolute!important;
  left: 93.5% !important;
  top: 0px!important;
  opacity: .9!important;*/
}
</style>
